import React from 'react';
import QuoteForm from '../../components/pure/forms/QuoteForm';

const VidaQuote = () => {
    return (
        <>
            <h1>Nueva solicitud de cotización de auto</h1>

            <QuoteForm />
        </>
    );
}

export default VidaQuote;
